export default __webpack_public_path__ + "static/media/Candado.914f255e.svg";